import styled from 'styled-components';

export const Wrapper = styled.li`
    margin-bottom: 1.5rem;
    padding: 2rem;
    border: 1px solid #ddd;
    background-color: #fafafa;
`;
